'use client';

export function SearchForm({
  initialQuery = '',
  compact = false,
}: {
  initialQuery?: string;
  compact?: boolean;
}) {
  return (
    <form action="/buscar" method="GET" className="relative">
      <svg
        viewBox="0 0 20 20"
        fill="currentColor"
        className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-neutral"
      >
        <path
          fillRule="evenodd"
          d="M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.45 4.39l3.08 3.08a.75.75 0 1 1-1.06 1.06l-3.08-3.08A7 7 0 0 1 2 9Z"
          clipRule="evenodd"
        />
      </svg>
      <input
        type="search"
        name="q"
        defaultValue={initialQuery}
        placeholder="Busca deshumidificadores, calefactores, aspiradores…"
        className={`w-full rounded-lg border border-gray-border bg-white py-3 pl-10 pr-4 text-sm text-navy placeholder:text-gray-neutral/70 focus:border-cobalt focus:outline-none ${
          compact ? 'py-2' : ''
        }`}
      />
    </form>
  );
}
